import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c7db5968&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7db5968",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7db5968')) {
      api.createRecord('c7db5968', component.options)
    } else {
      api.reload('c7db5968', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c7db5968&scoped=true&", function () {
      api.rerender('c7db5968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/city-store-manage/modules/product-supplement-dialog/index.vue"
export default component.exports